// /users — список пользователей; карточка /users/:id открывается боковой панелью поверх живого
// списка (contracts/ui.md). Право — users.read.
import { Outlet, createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { useCallback } from 'react';
import { UsersPage } from '../../../features/users/UsersPage.tsx';
import { parseUsersSearch } from '../../../features/users/search.ts';
import type { UsersSearch } from '../../../features/users/search.ts';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/users')({
  validateSearch: parseUsersSearch,
  beforeLoad: requireSection('users'),
  staticData: { crumb: 'Пользователи' },
  component: UsersRoute,
});

function UsersRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const params = useParams({ strict: false });
  const onSearchChange = useCallback(
    (next: UsersSearch) => void navigate({ to: '.', search: next, replace: true }),
    [navigate],
  );
  const onOpen = useCallback(
    (id: string) => void navigate({ to: '/users/$id', params: { id }, search: (prev) => prev }),
    [navigate],
  );
  return (
    <>
      <UsersPage
        search={search}
        onSearchChange={onSearchChange}
        selectedId={params.id}
        onOpen={onOpen}
      />
      <Outlet />
    </>
  );
}
